/* eslint-disable @typescript-eslint/no-unused-vars */
import useMediaQuery from "@mui/material/useMediaQuery";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import Button from "components/Buttons/ThemeButton";
import Countdown from "components/CountdownV2";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useWebStoreContext } from "contexts";
import { useAppDispatch, useImagePath } from "hooks";
import { clubGiftsGaloreAssets } from "assets/cdn";
import { ClubGiftsGaloreResponse, Tier } from "interfaces/club-gifts-galore-v2";
import { FeatureType } from "interfaces/feature-tracker";
import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { featureTrackerAPI } from "redux/apis";
import { onClosePopUp } from "redux/slices";
import { Container, ContributionsLeft, timeStyle } from "./styles";

interface CGGNotYetContributedProps {}

export const CGGNotYetContributed: React.FC<CGGNotYetContributedProps> = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const { getImage } = useImagePath("cdn");
	const { backgroundLandscape, backgroundPortrait } =
		clubGiftsGaloreAssets.v2.popups.notYetContributed;
	const scale = useCalculateScale(
		isPortrait ? 400 : 800,
		isPortrait ? 700 : 400
	);
	const { authToken, userTracker, nowTime } = useWebStoreContext();
	const [currentTier, setCurrentTier] = useState<Tier>();

	const { data }: { data?: ClubGiftsGaloreResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: FeatureType.CLUB_GIFT_BONUS_V2,
			isAuthenticated: !!authToken?.value
		});

	const onClose = () => {
		dispatch(onClosePopUp());
	};

	const handleClick = () => {
		if (userTracker?.clubId) {
			navigate("/club-shop");
			onClose();
		}
	};

	useEffect(() => {
		if (data?.tracker?.activeTierIndex === undefined) {
			onClose();
		} else {
			setCurrentTier(data?.tracker?.tiers[data.tracker.activeTierIndex]);
		}
	}, [data?.tracker]);

	if (!data?.tracker || !currentTier) {
		return <Fragment />;
	}

	return (
		<Container
			bgImage={getImage(isPortrait ? backgroundPortrait : backgroundLandscape)}
			scale={scale}
		>
			<Countdown
				// @ts-ignore
				endTime={data.tracker.endTime}
				startTime={nowTime}
				text={"Event ends in:"}
				className="dip-countdown"
				onEnd={onClose}
				hideTimerDisplayOnEnd={true}
				style={timeStyle}
			/>
			<CloseIconButton onClose={onClose} />
			<ContributionsLeft isPortrait={isPortrait}>
				{currentTier.requiredContributionCount - currentTier.contributionCount}
			</ContributionsLeft>
			<Button onClick={handleClick}>To Club Shop!</Button>
		</Container>
	);
};
